import styled from '@emotion/styled';
import { setMargin } from '../../../helpers';

export const OptionalTag = styled.span`
  ${setMargin};
  display: inline-block;
  font-weight: 400 !important;
  color: ${({ theme }) => theme.colors.neutralMain};
`;
